import * as React from "react";
import TruncatedText from "shiitake";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { inject } from "mobx-react";
import { ContextStore } from "bernie-core";
import { formatText } from "bernie-l10n";

interface ReviewTitleAndRatingProps {
  reviewTitle?: string;
  rating: string;
  context?: ContextStore;
}

const ReviewTitleAndRating = (props: ReviewTitleAndRatingProps) => (
  <Viewport>
    <ViewSmall>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-heading-500">
          <TruncatedText lines={2} renderFullOnServer={true}>
            {props.reviewTitle ||
              formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
          </TruncatedText>
        </div>
        <div>{formatText("hotelRecentReviews.outOf5Rating", props.rating)}</div>
      </div>
    </ViewSmall>
    <ViewMedium>
      <div className="uitk-cell all-y-padding-one">
        <div className="uitk-type-heading-500">
          <TruncatedText lines={2} renderFullOnServer={true}>
            {props.reviewTitle ||
              formatText("hotelRecentReviews.verifiedBrandReview", props.context!.site.name)}
          </TruncatedText>
        </div>
        <div className="reviewRating uitk-type-medium uitk-type-300">
          {formatText("hotelRecentReviews.outOf5Rating", props.rating)}
        </div>
      </div>
    </ViewMedium>
  </Viewport>
);

export default inject("context")(ReviewTitleAndRating);
